import * as React from "react";
import { SVGProps } from "react";

const Xyo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 386 335" {...props}>
    <g fill="#8c91c7">
      <path d="M289 0 95.8.9 0 168.7l97.4 166.9 193.2-.9 95.8-167.8zm-10.6 313.8-169 .8-85.2-146L108 21.8l169-.8 85.2 146z" />
      <path d="M307.1 133.6h-11.2l-20.7-108-117.1 37V52.3L273.9 16l9.3 4.3zM126.9 44l-7.3 4.6-19-29.3h10.3zm2 49h9.7v145h-9.7zm-25.7 218.3 5.8 10.1 12.6-23.8-6.4-7.3zm175.7 9.8-2.8.3-115.4-39.6 2.5-8.2 110.4 36.8 23-110.8h9.6zM365.4 172h-28l.6-9.9 27.6-.1zm-204.2 85.3 119.7-68.6-6.4-7.7L157 249.5zm-53.9-7.1L18.2 172l1.4-12 92.8-82.4 5.2 8-90.7 82.2 86.8 75.7zm170.6-95-122-71.1 4.7-8.4 121.6 70.9z" />
    </g>
    <path
      fill="#f43b7b"
      d="M306.2 130.3c-20.4 0-37 16.6-37 37s16.6 37 37 37 37-16.6 37-37-16.5-37-37-37zm0 64.4c-15.1 0-27.3-12.2-27.3-27.3s12.2-27.3 27.3-27.3 27.3 12.2 27.3 27.3-12.2 27.3-27.3 27.3z"
    />
    <path
      fill="#5aa2da"
      d="M135.6 38c-16.4 0-29.7 13.3-29.7 29.7s13.3 29.7 29.7 29.7 29.7-13.3 29.7-29.7C165.2 51.2 152 38 135.6 38zm0 50.6c-11.6 0-21-9.4-21-21s9.4-21 21-21 21 9.4 21 21-9.4 21-21 21z"
    />
    <path
      fill="#f66f4d"
      d="M133.5 233.6c-19 0-34.5 15.4-34.5 34.5s15.4 34.5 34.5 34.5c19 0 34.5-15.4 34.5-34.5s-15.4-34.5-34.5-34.5zm0 59c-13.6 0-24.5-11-24.5-24.5 0-13.6 11-24.5 24.5-24.5 13.6 0 24.5 11 24.5 24.5.1 13.5-10.9 24.5-24.5 24.5z"
    />
  </svg>
);

export default Xyo;
